module.exports = __webpack_public_path__ + "static/img/文化遗产展馆.3fb2982b.png";